import React from 'react';
import { useBackgroundTask } from '../contexts/BackgroundTaskContext';
import '../styles/BackgroundTaskNotification.css';

const BackgroundTaskNotification = () => {
  const { tasks, removeTask, cancelTask, clearCompletedTasks } = useBackgroundTask();

  if (tasks.length === 0) return null;

  const processingTasks = tasks.filter(t => t.status === 'processing');
  const completedTasks = tasks.filter(t => t.status !== 'processing');

  console.log('[BackgroundTaskNotification] Rendering with tasks:', {
    total: tasks.length,
    processing: processingTasks.length,
    completed: completedTasks.length,
    tasks: tasks.map(t => ({ id: t.id, status: t.status, title: t.title }))
  });

  const handleCancelClick = (taskId) => {
    console.log('[BackgroundTaskNotification] Cancel button clicked for task:', taskId);
    cancelTask(taskId);
  };

  return (
    <div className="background-task-container">
      {/* Processing Tasks */}
      {processingTasks.map(task => (
        <div key={`processing-${task.id}`} className="background-task-notification processing">
          <div className="task-spinner"></div>
          <div className="task-content">
            <p className="task-title">{task.title}</p>
            <p className="task-subtitle">{task.subtitle}</p>
            {task.progress > 0 && (
              <div className="task-progress-bar">
                <div
                  className="task-progress-fill"
                  style={{ width: `${task.progress}%` }}
                ></div>
              </div>
            )}
          </div>
          <button
            className="task-cancel-btn"
            onClick={() => handleCancelClick(task.id)}
            title="Cancel this job"
          >
            Cancel
          </button>
        </div>
      ))}

      {/* Completed Tasks - Only show in notification area if manually viewed */}
      {completedTasks.map(task => (
        <div
          key={`completed-${task.id}`}
          className={`background-task-notification ${task.status}`}
        >
          <div className={`task-status-icon ${task.status}`}>
            {task.status === 'completed' ? '✓' : '✕'}
          </div>
          <div className="task-content">
            <p className="task-title">{task.title}</p>
            {task.resultMessage && (
              <p className="task-subtitle">{task.resultMessage}</p>
            )}
          </div>
          <button
            className="task-close-btn"
            onClick={() => removeTask(task.id)}
            title="Dismiss"
          >
            ×
          </button>
        </div>
      ))}

      {/* Clear Button */}
      {completedTasks.length > 0 && (
        <button
          className="clear-completed-btn"
          onClick={clearCompletedTasks}
        >
          Clear completed
        </button>
      )}
    </div>
  );
};

export default BackgroundTaskNotification;
